import {
  GlobalAction,
  GlobalActions,
  GlobalPut,
  ModalType,
  PreiseForDashboard,
  SavedState,
  WrappedSavedStatesLoaded,
} from '@ps20-frontend/shop-integration-redux';
import { App } from '@ps20-frontend/frontend-models';
import { call, select, take, takeEvery } from 'redux-saga/effects';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { IAppState } from '@ps20-frontend/apps/checkout-store';
import { showUnfAngaben } from '../selector/produkt.selector';

export function* watchUnfallPreiseResetAfterLoad() {
  yield takeEvery(
    GlobalActions.SAVED_STATES_LOADED,
    safeSaga(checkUnfallPreiseReset, App.SHOP_CHECKOUT),
  );
}

export function* checkUnfallPreiseReset(action: GlobalAction<WrappedSavedStatesLoaded>) {
  const actionPayload: SavedState = action.payload.savedSensitiveStatesLoaded;
  const state: IAppState = yield select();
  const globalPut = GlobalPut.getInstance();
  if (showUnfAngaben(state)) {
    if (actionPayload) {
      let timeDiff = Date.now();
      const preiseResetAction: GlobalAction<PreiseForDashboard> = yield take(
        GlobalActions.PREISE_RESET_DASHBOARD,
      );
      yield take(GlobalActions.ALL_TARIFIERUNGEN_HAVE_ENDED);
      timeDiff = Date.now() - timeDiff;

      if (timeDiff < 5000 && preiseResetAction.payload.appId === App.UNF) {
        const found = state.produkte.find(
          p => p.angebotsId === preiseResetAction.payload.angebotsId,
        );
        const bodyParams: Record<string, string> = {};
        if (found) {
          bodyParams['vp'] = found.versichertesRisiko;
        }

        yield call(
          globalPut.put.bind(globalPut),
          new GlobalActions().requestModal(ModalType.VP_ALTER_CHANGED, { bodyParams }),
        );
      }
    }
  }
}
